import { axiosCall, clientIdHeaderName } from '../../constants';
import { RoleModel } from '../models';
import { plainToInstance } from 'class-transformer';
import { CreateRoleDto } from './dto';

export const updateRole = async (
  getAccessTokenSilently: CallableFunction,
  clientId: string,
  name: string,
  description: string,
  roleId: number,
): Promise<RoleModel> => {
  return axiosCall<RoleModel>(
    getAccessTokenSilently,
    'roles/' + roleId,
    'put',
    plainToInstance(CreateRoleDto, {
      name,
      description,
    }),
    { [clientIdHeaderName]: clientId },
  );
};
